import { PagesProvider } from '@osmosis/nextjs-components/context/PagesProvider';

export { usePagesContext } from '@osmosis/nextjs-components/context/PagesProvider';

export type { ParsedQuery } from '@osmosis/nextjs-components/context/PagesProvider';

export default PagesProvider;
